// extracted by mini-css-extract-plugin
export default {"marginButton":"CasinoProviderButtons_marginButton__UKwQc","active":"CasinoProviderButtons_active__DM4D4","providersSvg":"CasinoProviderButtons_providersSvg__zVnfm"};